import { useGroundingStore } from '@/modules/Project/useGroundingStore'

export const useClickGroundingSource = () => {
  const groundingStore = useGroundingStore()
  return (sourceId: number) => {
    groundingStore.clickSource(sourceId)

    const claimIndicator = document.querySelector(
      `[data-claim-pill-claim][data-source="${sourceId}"][data-property-id="${groundingStore.field?.propertyId}"]`,
    )
    if (claimIndicator) {
      claimIndicator.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }
}
